export const SET_WEBP = "webp/SET_WEBP";
